import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoSelectOption, PoTableColumn, PoTableAction } from '@po-ui/ng-components';
import { ControlePesoProduto, defaultExpedicaoRomaneioItemDto, defaultExpedicaoRomaneioItemListaDto, defaultRomaneioDto, defaultRomaneioItem, defaultUR, ExpedicaoRomaneioItemDto, ExpedicaoRomaneioItemListaDto, RomaneioDto, RomaneioItem, UR } from '../interface/romaneio';
import { RomaneioService } from '../service/romaneio.service';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { Zpr, getZprDefault } from 'src/app/interface/zpr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-romaneio-recebimento',
  templateUrl: './romaneio-recebimento.component.html',
  styleUrls: ['./romaneio-recebimento.component.css']
})
export class RomaneioRecebimentoComponent implements OnInit {

  etiqueta: string = '';
  etiquetaRateio: string = '';
  codigoRomaneio: string = '';
  usuarioLogado: string = '';
  apareceInformacoes: boolean = false;
  podeAtivarDigitacao: boolean = false;
  podeAtivarDigitacaoFam: boolean = false;
  zprPermissaoDigitarPeso: Zpr = getZprDefault();
  listaFamiliaDigitacao: Array<string> = []

  imprimirEtiquetaCliente: boolean = false;
  disabledPeso: boolean = true;

  romaneio: RomaneioDto;
  expedicaoRomaneioItem: ExpedicaoRomaneioItemDto;
  etiquetasBipadas: ExpedicaoRomaneioItemListaDto = defaultExpedicaoRomaneioItemListaDto();

  impressora: string = '';
  nCopias: string = '1';
  loteSelecionado: string = '';
  pesagem: string = '';
  pesoRateio: number = 0;

  URselecionada: number = 0;
  dadosEtiqueta: ExpedicaoRomaneioItemDto = defaultExpedicaoRomaneioItemDto();

  zprAdvancedFilters: Array<PoDynamicFormField>;
  zprColumnsFilters: Array<PoLookupColumn>;
  zprFieldFormaterFilters: (value: Zpr) => string;

  varInformacao: Array<PoSelectOption>;

  urlApiProtheus: string = environment.urlApiProtheus;

  constructor(
    private romaneioService: RomaneioService,
    private route: ActivatedRoute,
    private poDialogService: PoDialogService,
    private router: Router,
    private poNotificationService: PoNotificationService,
    public zprService: ZprLookupService,
  ) {
    this.zprService.grupo = 'PRINTLIST';
    this.expedicaoRomaneioItem = defaultExpedicaoRomaneioItemDto();
    this.romaneio = defaultRomaneioDto();

    this.varInformacao = this.listaInformacao();

    this.zprAdvancedFilters      = this.zprService.getAdvancedFilter();
    this.zprColumnsFilters       = this.zprService.getColumnsFilterCompleto();
    this.zprFieldFormaterFilters = this.zprService.getFieldFormater;
  }

  @ViewChild('recebimentoModal', { static: true }) recebimentoModal!: PoModalComponent;
  @ViewChild('recebimentoRateioModal', { static: true }) recebimentoRateioModal!: PoModalComponent;
  @ViewChild('impressaoEtiquetaModal', {static: true}) impressaoEtiquetaModal!: PoModalComponent;
  @ViewChild('modalAlteraUR', {static: true}) modalAlteraUR!: PoModalComponent;

  ngOnInit(): void {

    this.pesoRateio = 0;
    this.usuarioLogado = localStorage.getItem('CUSRID') || '';
    this.zprService.grupo = 'PESOROMPRM';
    this.zprService.getZprLista().subscribe((ret) => {
      ret.items.map((item) => {
        if (this.usuarioLogado == item.CZPRCHAVE) {
          this.podeAtivarDigitacao = true;
        }
      });
    });
    this.zprService.getObjectByValue('PERMISSAO').subscribe((ret) => {
      this.zprPermissaoDigitarPeso = ret;
    });

    
    this.zprService.getObjectByValue('PERFAMILIA').subscribe((ret) => {
      this.listaFamiliaDigitacao = ret.CZPRGENERI.split("|");
    });
  
    this.route.params.subscribe((params) => {

      if ('CZ00COD' in params) {
        this.codigoRomaneio = params['CZ00COD'];

        this.romaneioService.getLoadRomaneioRecimento(this.codigoRomaneio).subscribe(romaneio => {
          this.romaneio = romaneio;
          this.romaneio.items = this.romaneio.items.map((item) => {
            return { ...item, favorite: ['etqCliente', 'excluir'] };
          });
          this.romaneio.itemsRecebidos = this.romaneio.itemsRecebidos.map((item) => {
            return { ...item, favorite: ['etqCliente', 'alteraur'] };
          });
        }, (e) => {
          this.poDialogService.alert({
            title: 'ATENÇÃO',
            message: 'Romaneio Inválido.',
            ok: () => this.goTo()
          });
        });
      }
    });

    this.zprService.grupo = 'PRINTLIST';
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Recebimento Romaneio', action: this.goTo.bind(this) },
      { label: 'Lista', action: this.goToLista.bind(this) },
      { label: 'Receber' }
    ]
  };

  goTo(): void {
    this.router.navigateByUrl('');
  }

  goToLista(): void {
    this.router.navigateByUrl('/estoque/romaneio/recebimento/lista');
  }

  public readonly actions: Array<PoPageAction> = [
    { label: 'Finalizar', action: this.optionFinalizarRomaneio.bind(this)},
    { label: 'Imprimir Selecionadas', action: this.imprimirSelecionadas.bind(this)},
  ];

  public readonly colunas: Array<PoTableColumn> = [
    {property: 'CTEMRECEBIDO', label: 'Status', width: '07%', type: 'subtitle',
      subtitles: [
        {value: 'N', content: 'P', color: 'color-01', label: 'Pendente'},
        {value: 'S', content: 'R', color: 'color-10', label: 'Recebido'},
      ]
    },
    {property: 'CZ01ETIQ' , label: 'Etiqueta'},
    {property: 'CB1COD'   , label: 'Produto'},
    {property: 'CB1DESC'  , label: 'Descrição'},
    {property: 'NZ01QUANT', label: 'Quantidade'},
    {property: 'NZ02PESO', label: 'Peso'},
    {property: 'favorite' , label: '...'             , width: '15%' , type: 'icon',
      icons: [
        {
          action: this.btnExcluirEtiqueta.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Excluir Etiqueta',
          value: 'excluir',
        }
      ]
    }
  ];

  public readonly colunasEtiquetasBipadas: Array<PoTableColumn> = [
    
    {property: 'CZ02LOTE' , label: 'Etiqueta'},
    {property: 'CZ02PRAT' , label: 'Prateleira'},
    {property: 'CZ02INFORM', label: 'T ou E', width: '07%', type: 'subtitle',
      subtitles: [
        {value: 'T', content: 'T', color: 'color-01', label: 'Toco'},
        {value: 'E', content: 'E', color: 'color-10', label: 'Esqui'},
      ]
    },
    {property: 'NZ02PESO', label: 'Peso'},
    {property: 'favorite' , label: '...'             , width: '15%' , type: 'icon',
      icons: [
        {
          action: this.btnExcluirEtiquetaRateio.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Excluir Etiqueta',
          value: 'excluir',
        }
      ]
    }
  ];

  public readonly tabelaPrincipalActions: Array<PoTableAction> = [
    { label: 'Etiqueta Cliente', icon: 'po-icon-credit-payment', action: this.btnEtiquetaCliente.bind(this), disabled: this.temRecebido.bind(this) },
    { label: 'Alterar UR', icon: 'po-icon-edit', action: this.btnAlteraUR.bind(this), disabled: this.temRecebido.bind(this) },
  ];

  finalizarRomaneio(): void {
    this.romaneioService.finalizarRomaneio(this.codigoRomaneio).subscribe((ret) => {
      this.poNotificationService.success("Romaneio finalizado com sucesso!");
      this.router.navigateByUrl('/estoque/romaneio/recebimento/lista');
    });
  }

  optionFinalizarRomaneio(): void {
    let possuiPendente: boolean = false;

    this.romaneio.items.forEach(Item =>{
      if(Item.CTEMRECEBIDO === 'N'){
        possuiPendente = true
      }
    })

    if (!possuiPendente) {
      this.finalizarRomaneio();
    }
  }

  biparEtiqueta(isUniq: boolean): void {
    let continua = true;
    if (isUniq) {
      this.etiquetasBipadas.items = [];
    } else {
      this.etiqueta = this.etiquetaRateio;
      if (this.etiquetasBipadas.items.filter(item=>item.CZ02LOTE == this.etiqueta).length > 0) {
        this.poNotificationService.error("A etiqueta já está no rateio.");
        continua = false;
      }
    }

    if (continua) {
      if (this.pesagem == '' || this.pesagem == undefined) {
        this.poNotificationService.error("Antes de bipar uma etiqueta seleciona a forma de pesagem.");
      } else {
        this.expedicaoRomaneioItem = defaultExpedicaoRomaneioItemDto();
        let achou = false;
        let recebido = false;
        if (this.etiqueta != '') {
          let etiq = this.etiqueta;
          if (etiq.length > 7 && etiq.substring(0,3) == "000") {
            etiq = etiq.substring(3,etiq.length);
          }
          this.romaneio.items.map((item) => {
            if (item.CZ01ETIQ == etiq) {
              this.expedicaoRomaneioItem.CZ02LOTE = item.CZ01ETIQ;
              this.expedicaoRomaneioItem.CZ02CODZ00 = this.codigoRomaneio;
              this.expedicaoRomaneioItem.CB1COD = item.CB1COD;
              this.expedicaoRomaneioItem.CB1DESC = item.CB1DESC;
              this.expedicaoRomaneioItem.NZ01QUANT = item.NZ01QUANT;
              this.expedicaoRomaneioItem.CB1XFAM = item.CB1XFAM;
              achou = true;
              if (item.CTEMRECEBIDO === 'S'){
                recebido = true
              }
            }
          });
          this.etiqueta = '';
          if (achou) {
            if (recebido){
              this.poNotificationService.warning('Etiqueta já recebida.')
            } else {
              if (this.romaneio.CZ00DESTIN == 'BA') {
                if (this.listaFamiliaDigitacao.filter((item) => item.trim() == this.expedicaoRomaneioItem.CB1XFAM.trim()).length > 0) {
                  this.podeAtivarDigitacaoFam = true;
                } else {
                  this.podeAtivarDigitacaoFam = false;
                }
                this.expedicaoRomaneioItem.CZ02INFORM = 'T';
                this.disabledPeso = true;
                if (isUniq) {
                  if (this.pesagem == '2') {
                    this.recebimentoRateioModal.open();
                  } else {
                    this.recebimentoModal.open();
                  }
                }
              } else {
                this.confirmarRecebimento(isUniq);
              }
            }
          }
        }
      }
    }
  }

  trocaEtiquetaAutomatica(): void {
    this.loteSelecionado = "";
    if (this.imprimirEtiquetaCliente) {
      this.impressora = "PDF";
      this.impressaoEtiquetaModal.open();
    }
  }

  public readonly confirmarRecebimentoAction: PoModalAction = {
    action: () => {
      if (this.expedicaoRomaneioItem.NZ02PESO > 0) {
        this.recebimentoModal.close();
        this.confirmarRecebimento(true);
      } else {
        this.poNotificationService.error("O peso deve ser maior que 0.");
      }
    },
    label: 'Confirmar'
  };

  public readonly confirmarRecebimentoRateioAction: PoModalAction = {
    action: () => {
      if (this.etiquetasBipadas.items[0].NZ02PESO > 0) {
        this.recebimentoRateioModal.close();
        this.confirmarRecebimento(false);
      } else {
        this.poNotificationService.error("O peso deve ser maior que 0.");
      }
    },
    label: 'Confirmar'
  };

  btnEtiquetaCliente(row: RomaneioItem): void {
    this.loteSelecionado = row.CZ01ETIQ;
    this.impressaoEtiquetaModal.open();
  }

  btnAlteraUR(row: RomaneioItem): void {
    this.URselecionada = 0;
    this.dadosEtiqueta = defaultExpedicaoRomaneioItemDto();

    this.romaneio.itemsRecebidos.filter((item) => item.CZ02LOTE === row.CZ01ETIQ ).map((item, index) => {
      this.URselecionada = item.NZ05RECNO;
      this.dadosEtiqueta = item;
    });

    this.modalAlteraUR.open();
  };

  salvarAlteraUR(): void {
    this.romaneioService.postAlterarUR(this.dadosEtiqueta.CZ02COD,this.dadosEtiqueta.CZ02UR,this.dadosEtiqueta.CZ02LOTE,this.dadosEtiqueta.CB1COD,this.URselecionada).subscribe({
      next: (ret) => {
        this.poNotificationService.success(`UR alterada com sucesso!`);
        this.modalAlteraUR.close();
        this.ngOnInit()
      }
    });
  };

  fecharAlteraUR(): void {
    this.URselecionada = 0;
    this.dadosEtiqueta = defaultExpedicaoRomaneioItemDto();
    this.modalAlteraUR.close();
  };

  public readonly gerarEtiquetaClienteAction: PoModalAction = {
    action: () => {
      this.impressaoEtiquetaModal.close();
      if (this.loteSelecionado != "") {
        this.romaneioService.getEtiquetaCliente(this.loteSelecionado, this.impressora, this.nCopias, 'S').subscribe((res) => {
          if (this.impressora == "PDF") {
            var file = new Blob([res], {type: 'application/pdf'});
            var fileName = `ETIQUETA_CLIENTE_${this.loteSelecionado}_${new Date().toLocaleString()}.pdf`;
            var a = document.createElement("a");
            document.body.appendChild(a);

            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
          } else {
            this.poNotificationService.success("Etiqueta enviada para impressão!")
          }
        });
      }
    },
    label: 'Selecionar',
  };

  btnExcluirEtiqueta(row: RomaneioItem): void {
    this.poDialogService.confirm({
      title: 'Confirmar Exclusão',
      message: 'Deseja realmente confirmar a exclusão da etiqueta?',
      confirm: () => this.excluirEtiqueta(row)
    });
  }

  excluirEtiqueta(row: RomaneioItem): void {
    this.romaneioService.removerEtiquetaRecebimento(this.romaneio.CZ00COD, row.CZ01ETIQ).subscribe((ret) => {
      this.romaneio.items = this.romaneio.items.filter((item) => {
        return item.CZ01ETIQ != row.CZ01ETIQ;
      });
      this.poNotificationService.success("Etiqueta excluída com sucesso!");
    })
  }

  geraEtiquetaCliente(lote: string): void  {
    this.romaneioService.getEtiquetaCliente(lote, this.impressora, this.nCopias, 'S').subscribe((res) => {
      if (this.impressora == "PDF") {
        var file = new Blob([res], {type: 'application/pdf'});
        var fileName = `ETIQUETA_CLIENTE_${this.loteSelecionado}_${new Date().toLocaleString()}.pdf`;
        var a = document.createElement("a");
        document.body.appendChild(a);

        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
      } else {
        this.poNotificationService.success("Etiqueta enviada para impressão!")
      }
    });
  }

  confirmarRecebimento(isUniq: boolean): void {

    if(isUniq) {
      this.etiquetasBipadas.items = [this.expedicaoRomaneioItem];

      if (this.pesagem == '3') {
        this.romaneio.items.map((item) => {
          if (item.CTEMRECEBIDO == 'N' && item.NZ01QUANT == this.expedicaoRomaneioItem.NZ01QUANT && item.CB1COD == this.expedicaoRomaneioItem.CB1COD && item.CZ01ETIQ != this.expedicaoRomaneioItem.CZ02LOTE) {
            this.etiquetasBipadas.items.push({...this.expedicaoRomaneioItem, CZ02LOTE: item.CZ01ETIQ });
          }
        })
      }
    }

    this.processarEtiquetasComDelay();

  }

  async processarEtiquetasComDelay() {
    let possuiPendente: boolean = false;

    for (const etiqueta of this.etiquetasBipadas.items) {
      // Wrap the inner logic in a Promise to await the observable completion
      await new Promise<void>((resolve, reject) => {
        this.romaneioService.confirmarRecebimentoEtiqueta(etiqueta).subscribe({
          next: (ret) => {
            this.romaneio.items = this.romaneio.items.filter((item) => {
              return item.CZ01ETIQ != etiqueta.CZ02LOTE;
            });
            etiqueta.CZ02COD = ret.CZ02COD;
            this.romaneio.itemsRecebidos.push({...etiqueta });

            if (this.imprimirEtiquetaCliente) {
              this.geraEtiquetaCliente(etiqueta.CZ02LOTE);
            }

            this.romaneio.items.forEach(Item =>{
              if(Item.CTEMRECEBIDO === 'N'){
                possuiPendente = true
              }
            });

            if (!possuiPendente && this.pesagem != '3') {
              this.finalizarRomaneio();
            }
            this.ngOnInit();
            resolve(); // Resolve a Promise após a conclusão do subscribe
          },
          error: (err) => {
            reject(err); // Rejeita a Promise em caso de erro
          }
        });
      });
    }
  }

  sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  confirmarItemRateio(): void {
    this.etiquetasBipadas.items.push({...this.expedicaoRomaneioItem, favorite: ['excluir'] });
    this.expedicaoRomaneioItem = defaultExpedicaoRomaneioItemDto();
    this.distribuirPesoRateio();
    this.etiquetaRateio = '';
  }

  clickInformacoes(): void {
    this.apareceInformacoes = !this.apareceInformacoes;
  }

  listaInformacao(): Array<PoSelectOption> {
    return [
        { value: "T", label: "Toco"   },
        { value: "E", label: "Esqui"  },
    ];
  }

  pesar(): void {
    this.romaneioService.pesar().subscribe((ret) => {
      if (ret['NPESO'] > 0) {
        this.disabledPeso = true;
        this.expedicaoRomaneioItem.NZ02PESO = ret['NPESO'];
      } else {
        this.disabledPeso = false;
      }
    });
  }

  pesarRateio(): void {
    this.romaneioService.pesar().subscribe((ret) => {
      if (ret['NPESO'] > 0) {
        this.disabledPeso = true;
        this.pesoRateio = ret['NPESO'];
        this.distribuirPesoRateio();
      } else {
        this.disabledPeso = false;
      }
    });
  }

  distribuirPesoRateio(): void {
    debugger;
    let pesoPorEtiqueta = (this.pesoRateio/this.etiquetasBipadas.items.length)|0;
    let diferenca = this.pesoRateio - (pesoPorEtiqueta * this.etiquetasBipadas.items.length)

    this.etiquetasBipadas.items = this.etiquetasBipadas.items.map((item) => {
      return {...item, NZ02PESO: pesoPorEtiqueta};
    });

    for (let x = 0; x > diferenca; diferenca++) {
      this.etiquetasBipadas.items[x].NZ02PESO+=1;
    }
  }

  alteraPermissaoPesagem(): void {
    let novaPermissao = this.zprPermissaoDigitarPeso.CZPRGENERI == 'S' ? 'N' : 'S';
    this.zprService.putZpr({...this.zprPermissaoDigitarPeso, CZPRGENERI: novaPermissao}).subscribe(() => {
      this.zprPermissaoDigitarPeso.CZPRGENERI = novaPermissao;
    });
  }

  temRecebido(row: any): boolean {
    return row.CTEMRECEBIDO === 'N'?true:false;
  }

  btnExcluirEtiquetaRateio(row: ExpedicaoRomaneioItemDto): void {
    this.poDialogService.confirm({
      title: 'Confirmar Exclusão',
      message: 'Deseja realmente a exclusão da etiqueta do rateio?',
      confirm: () => this.excluirEtiquetaRateio(row)
    });
  }

  excluirEtiquetaRateio(row: ExpedicaoRomaneioItemDto): void {
    this.etiquetasBipadas.items = this.etiquetasBipadas.items.filter((item) => {
      return item.CZ02LOTE != row.CZ02LOTE;
    });
    
    this.distribuirPesoRateio();
  }

  imprimirSelecionadas(): void {
    let selecionadas = this.romaneio.items.filter((item) => item.$selected);

    selecionadas.map((etiqSelecionada) => {
      this.geraEtiquetaCliente(etiqSelecionada.CZ01ETIQ);
    })
  }

}

